// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.additional-card-info {
  color: darkgray;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/app/capd-client-mock/capd-client-response/capd-client-response.component.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,kBAAA;AACF","sourcesContent":[".additional-card-info {\n  color: darkgray;\n  font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
